import styled from 'styled-components';

const BulletPoint = styled.span`
  border: 2px solid var(--grey700);
  border-radius: 50%;
  height: 2px;
  margin: 0 8px;
  align-self: center;
`;
export default BulletPoint;
